module.exports = __webpack_public_path__ + "static/media/home-img02.3afdc5ca.jpg";